/* eslint-disable complexity */
import { Pickable } from '@app/engine/core/interfaces';
import { html } from '@app/engine/utils/development/formatter';
import { ColorScheme } from './color-scheme';
export class ConfidenceColorScheme extends ColorScheme {
    label = 'Confidence';
    id = 'ConfidenceColorScheme';
    static id = 'ConfidenceColorScheme';
    static uniqueObjectTypeFlags = {
        confidenceHi: true,
        confidenceMed: true,
        confidenceLow: true,
    };
    static uniqueColorTheme = {
        confidenceHi: [0.0, 1.0, 0.0, 1.0],
        confidenceMed: [1.0, 1.0, 0.0, 1.0],
        confidenceLow: [1.0, 0.0, 0.0, 1.0],
    };
    constructor() {
        super(ConfidenceColorScheme.uniqueColorTheme);
        this.objectTypeFlags = {
            ...this.objectTypeFlags, ...ConfidenceColorScheme.uniqueObjectTypeFlags,
        };
    }
    update(obj) {
        if (!obj.isSatellite()) {
            return {
                color: this.colorTheme.transparent,
                pickable: Pickable.No,
            };
        }
        const sat = obj;
        const confidenceScore = parseInt(sat.tle1.substring(64, 65)) || 0;
        let pickable;
        let color;
        if (confidenceScore >= 7 && this.objectTypeFlags.confidenceHi) {
            color = this.colorTheme.confidenceHi;
            pickable = Pickable.Yes;
        }
        else if (confidenceScore >= 4 && confidenceScore < 7 && this.objectTypeFlags.confidenceMed) {
            color = this.colorTheme.confidenceMed;
            pickable = Pickable.Yes;
        }
        else if (confidenceScore >= 0 && confidenceScore < 4 && this.objectTypeFlags.confidenceLow) {
            color = this.colorTheme.confidenceLow;
            pickable = Pickable.Yes;
        }
        else {
            color = this.colorTheme.transparent;
            pickable = Pickable.No;
        }
        return {
            color,
            pickable,
        };
    }
    static layersHtml = html `
  <ul id="layers-list-confidence">
    <li>
      <div class="Square-Box layers-confidenceLow-box"></div>
      3 or Lower
    </li>
    <li>
      <div class="Square-Box layers-confidenceMed-box"></div>
      Between 3 and 7
    </li>
    <li>
      <div class="Square-Box layers-confidenceHi-box"></div>
      7 or Higher
    </li>
  </ul>
  `.trim();
}
